export default function AllMaterials() {
  const checks = [
    "PVC : crémone encastrée dans le profilé, remplacement par l'entrebâilleur",
    "Aluminium : mécanisme souvent plus robuste, mais spécifique à chaque fabricant",
    "Bois : dormant plus épais, crémone adaptée à l'épaisseur du profilé",
    "Ferco : système de galets et crochets très répandu en France",
    "GU / Roto : crémones à tiges métalliques, durables et précises",
    "Maco / Siegenia : mécanismes à compas, pièces toujours disponibles",
    "Winkhaus / Aubi : systèmes fermés, remplacement par crémone d'origine",
    "Cadiou et autres anciennes marques : nous trouvons la pièce compatible",
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Tous types de menuiserie
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Remplacement <span className="font-serif italic">PVC, alu et bois</span>, toutes marques
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed mb-10">
            <p>
              Quel que soit le matériau de votre fenêtre, la crémone est spécifique à la section du profilé et à l'épaisseur de l'ouvrant. Sur une fenêtre PVC, la crémone est généralement encastrée dans le dormant et accessible par l'entrebâilleur une fois la fenêtre ouverte. Sur aluminium, le mécanisme est plus compact et souvent plus robuste, mais il nécessite une pièce exactement adaptée à la marque du profilé. Sur bois, l'épaisseur du dormant impose une crémone avec des tiges plus longues et des points de fermeture positionnés différemment.
            </p>
            <p>
              Nos techniciens interviennent sur toutes les marques et tous les matériaux. Nous diagnostiquons sur place, identifions la crémone exacte nécessaire, et la remplaçons avec une pièce neuve d'origine ou compatible. Pas besoin de connaître la marque de votre fenêtre : nous la reconnaissons au premier coup d'œil. Le remplacement est rapide, propre, et ne laisse aucune trace sur la menuiserie existante.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8">
            <h3 className="font-semibold text-plum text-base md:text-lg mb-5">
              Matériaux et marques que nous réparons régulièrement
            </h3>
            <ul className="space-y-3">
              {checks.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-coral text-sm" />
                  </div>
                  <span className="text-sm md:text-base text-plum-dark">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}